export default item => ({
  field: item.source,
  message: `${item.title}: ${item.detail}`
})